import { createIcon, Path } from './index';

export const IconAppleWhite = createIcon({
  title: 'An apple icon.',
  viewBox: '0 0 32 32',
  path: [
    <Path
      d="M16.0003 27.92C18.0003 27.92 19.667 29.3334 21.3337 29.3334C25.3337 29.3334 29.3337 18.6667 29.3337 13.04C29.2882 11.313 28.562 9.67392 27.3132 8.48008C26.0644 7.28624 24.3943 6.63442 22.667 6.66669C19.707 6.66669 17.3337 8.58669 16.0003 9.33335C14.667 8.58669 12.2937 6.66669 9.33366 6.66669C7.60533 6.6309 5.93326 7.28155 4.6837 8.47613C3.43414 9.67071 2.70896 11.3118 2.66699 13.04C2.66699 18.6667 6.66699 29.3334 10.667 29.3334C12.3337 29.3334 14.0003 27.92 16.0003 27.92Z"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <Path
      d="M13.333 2.66669C14.6663 3.33335 15.9997 5.33335 15.9997 9.33335"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});
